// extracted by mini-css-extract-plugin
export var label = "_dy-2";
export var slideContainer = "_dy-0";
export var slider = "_dy-1";